import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UpdateProfileUserDto, UpdateProfileUserEntity, BankAccountService, RemoveBankAccountEntity, CreateBankAccountDto, CreateBankAccountEntity } from 'services/openapi';

import { BankAccountServiceQueryKeys } from '../constants';

export const useCreateAccountBankMutation = () => {
  const queryClient = useQueryClient();

  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } = useMutation<
    CreateBankAccountEntity,
    Error,
    CreateBankAccountDto
  >({
    mutationFn: (variables: CreateBankAccountDto) => {
      return BankAccountService.bankAccountControllerCreatePinCode(variables);
    },
    onSuccess: () => Promise.all([queryClient.invalidateQueries([BankAccountServiceQueryKeys.CREATE_ACCOUNT_BANK])]),
  });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
